module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('strong', [_c('em', [_vm._v("1."), _c('br'), _vm._v("Why Natives?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Southwestern deserts contain some of the most unique natural landscapes in the world. Rugged mountain ranges, gentle plains, and sandy arroyos support a great diversity of plants, from the gnarled Ironwood tree to the delicate Mexican Gold-poppy. The vegetation may be complex, with an intermingling of trees, shrubs, cacti, other succulents, and groundcovers, or a more simple composition of two to three dominant plant species. Sometimes the plainest landscape becomes breathtakingly beautiful, such as when abundant rainfall coupled with mild temperatures coax forth a tapestry of wildflowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can look to the desert for inspiration and incorporate some of that natural beauty into your own planned landscape. Plants native to the Southwestern deserts can fulfill both aesthetic and functional needs in exchange for very little attention. These plants have adapted to the desert’s harsh conditions over thousands of years, so they’re used to the temperature extremes, intense sunlight, low humidity, drying winds, and poor soils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An important benefit of incorporating native plants into planned landscapes is that of replacing some of the natural vegetation that was displaced by development. While it is not possible to replicate nature, you can restore a small part of the desert ecosystem. Wildlife will be attracted to a landscape with native plants, which can provide shelter, nesting material, and food.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nowhere else in this country can planned landscapes so reflect the natural beauty of the desert. Southwestern gardeners have a unique opportunity to develop a landscape with regional character by choosing from the wonderful variety of native plants.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("DESERT PROFILES")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The three warm deserts that cover much of the Southwestern United States and Northern Mexico are the Mojave, Sonoran, and Chihuahuan. Although they share the characteristics of low rainfall, high temperatures, and in some cases common plant species, each desert has a distinct character.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("MOJAVE DESERT")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Mojave Desert is dominated by low, widely spaced shrubs. Creosote Bush ("), _c('em', [_vm._v("Larrea tridentata")]), _vm._v(") and White Bur-sage ("), _c('em', [_vm._v("Ambrosia dumosa")]), _vm._v(") are two of the most common species. The cacti are mostly low-growing Prickly-pear and Cholla ("), _c('em', [_vm._v("Opuntia species")]), _vm._v("). Short-lived annual wild-flowers brighten the Mojave Desert in late March, April, and May, when prompted by winter rains. Trees are limited, although the distinctive Joshua Tree ("), _c('em', [_vm._v("Yucca brevifolia")]), _vm._v(") occurs in the higher elevations, and its distribution essentially delineates the boundaries of this desert. Much of the Mojave Desert lies in southern California, with smaller portions in southern Nevada, southwestern Utah, and northwestern Arizona.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("The Mojave Desert receives most of its rainfall as gentle showers in the winter, between November and March. The moisture comes from the Pacific Ocean and decreases across the desert from west to east. Occasional summer thunderstorms occur in the eastern portion. Cold winters are the norm for this desert, although it also holds the record high temperature for North America: 134° F in Death Valley. Sections of the Mojave Desert lie below sea level, while the highest elevations are around 5,000 feet. About three-fourths of the desert lies between 2,000 and 4,000 feet in elevation.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("SONORAN DESERT")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most noticeable feature of the Sonoran Desert is its variety of plant forms: large cacti such as Saguaro, many types of smaller cacti, leaf succulents, trees, shrubs, herbaceous perennials, and annual wildflowers. There are also many different species of plants. This diversity of life forms and species can be credited to the Sonoran’s mild winters (some areas never experience freezing temperatures) and the moisture received throughout two rainy seasons. Gentle, widespread winter rains come from the Pacific Ocean, while summer thunderstorms that originate in the Gulfs of Mexico and California can dump large amounts of rain in a short period of time, but are often very localized.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Sonoran Desert is shaped somewhat like a horse shoe that wraps around the Gulf of California. More than two-thirds of its total area lies in Mexico, on the Baja California peninsula, and in the mainland state of Sonora. In the United States, this desert occupies extreme southeastern California and southwestern and south-central Arizona. Elevations in the Sonoran Desert range from below sea level to 3,450 feet, with the majority of the region lying below 2,000 feet.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0016-01.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHIHUAHUAN DESERT")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Chihuahuan Desert occurs primarily in the Mexican states of Chihuahua and Coahuila, with smaller portions in Durango, Zacatecas, Nuevo León, and Sonora. Western Texas and southern New Mexico contain significant areas of Chihuahuan Desert vegetation. The Chihuahuan Desert enters extreme southeastern Arizona in three relatively small sections. Some areas in this desert exceed 6,500 feet in elevation, while the lowest portion is along the Rio Grande, at 1,000 feet Much of the desert lies between 3,500 and 4,200 feet in elevation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shrubs are the dominant plant form in the Chihuahuan Desert. Trees are mostly confined to waterways or rocky hills. Leaf succulents most notably Lechuguilla ("), _c('em', [_vm._v("Agave lechuguilla")]), _vm._v("), are common, and a variety of small cacti also occur. The Chihuahuan Desert is characterized by hot summers and cold winters, with periods of up to seventy two hours below freezing. Summer precipitation originating in the Gulf of Mexico accounts for 70–80 percent of the annual rainfall.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0020-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "lev2"
    }
  }), _c('a', {
    attrs: {
      "id": "tab1"
    }
  }), _c('strong', [_vm._v("Table 1: Weather of Desert Cities")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0020-02.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0021-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f2eb46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292747364_09_ch1.vue
// module id = 84
// module chunks = 0